module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZAu9AN/tc-custom/9780061734106.jpg?1731838249880",
      "alt": "This image is the cover for the book 24 Declassified: Storm Force, Jack Bauer Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("24 Declassified: Storm Force, Jack Bauer Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Still reeling but rebuilding after Katrina's fury, New Orleans braces for another major hurricane heading her way. But a far greater threat is looming on the horizon—a manmade terror storm that will dwarf the destructive force of anything Mother Nature could have devised.")]), _c('p', [_vm._v("Following a tip, agent Jack Bauer has come to the Big Easy—and watches helplessly as two prime players representing America's most dangerous Latin American adversaries fall in a surprising hail of gunfire. With winds rapidly approaching gale force, the rogue CTU operative must now follow the blood trail to a completely unexpected source. Because in less than 24 hours, a ruthless enemy hiding among \"friends\" plans to take out the already damaged Crescent City—and deliver a staggering blow from which the U.S. \"Satan\" may never recover.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Jacobs\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0